import types from './types';

export function setOverlay(overlay) {
  return { type: types.SET_OVERLAY, payload: overlay };
}

export function setActiveAccount(accountId) {
  return { type: types.SET_ACTIVE_ACCOUNT, payload: accountId };
}

export function switchAccount(newAccountId) {
  return { type: types.SWITCH_ACCOUNT, payload: newAccountId };
}

export function doneSwitchingAccount() {
  return { type: types.SWITCHED_ACCOUNT };
}

export function setUserIsAdmin(isAdmin) {
  return { type: types.SET_IS_ADMIN, payload: isAdmin };
}

export function setNavRef(navRef) {
  return { type: types.SET_NAV_REF, payload: navRef };
}

export function setMenuRef(menuRef) {
  return { type: types.SET_MENU_REF, payload: menuRef };
}

export function setNavToggleRef(navToggleRef) {
  return { type: types.SET_NAV_TOGGLE_REF, payload: navToggleRef };
}

export function setMenuToggleRef(menuToggleRef) {
  return { type: types.SET_MENU_TOGGLE_REF, payload: menuToggleRef };
}

export function setPushNotification(pushNotification) {
  return { type: types.SET_PUSH_NOTIFICATION, payload: pushNotification };
}
